module.exports = __webpack_public_path__ + "static/media/android.610f46a5.jpg";